import { render, staticRenderFns } from "./flowRegit.vue?vue&type=template&id=7c4d1b9f&scoped=true"
import script from "./flowRegit.vue?vue&type=script&lang=js"
export * from "./flowRegit.vue?vue&type=script&lang=js"
import style0 from "./flowRegit.vue?vue&type=style&index=0&id=7c4d1b9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d1b9f",
  null
  
)

export default component.exports